import React from "react";

import styles from "./ToggleSwitch.module.css";
import { generateUUID } from "../utils/string-utils";

/**
 * A toggle switch component.
 * @param {string} size - size of the toggle switch
 * @param {boolean} checked - checked state of the toggle switch
 * @param {function} onCheckChange - function to handle the change of the checked state
 * @returns {JSX.Element} - ToggleSwitch component
 * @example
 * <ToggleSwitch
 *  size="1.5rem"
 *  checked={true}
 *  onCheckChange={(checked) => //console.log(checked)}
 * />
 */
const ToggleSwitch = ({ size, checked, onCheckChange, color }) => {
  const uniqueId = generateUUID();

  return (
    <label
      htmlFor={uniqueId}
      className={styles.switch}
      style={{ "--size": size }}
    >
      <input
        id={uniqueId}
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckChange(e.target.checked)}
      />
      <span className={styles.slider} style={{ backgroundColor: color }}></span>
    </label>
  );
};

export default ToggleSwitch;
